module.exports = __webpack_public_path__ + "static/media/fk.1e53dc26.svg";